<template>
  <li
    v-if="isAuthorized"
    class="promo-menu__item"
  >
    <a class="promo-menu__link" :href="link">
      <icon
        name="My_recommendations_16"
        role="img"
        class="promo-menu__icon _green"
        :width="16"
        :height="16"
      />
      {{ title }}
    </a>
  </li>
</template>

<script>
import PersonalRecommendationMixin from '@/js/vue/PersonalRecommendation/mixins/PersonalRecommendationMixin';
import Icon from '@/js/vue/Icon';

export default {
  name: 'PersonalRecommendationPromoMenuItem',
  components: {
    Icon,
  },
  mixins: [PersonalRecommendationMixin],
};
</script>
